// extracted by mini-css-extract-plugin
export default {"enter-manually-option":"Menu_enter-manually-option__JwHcC"};